import React from "react";
import banner from "../Assets/Images/contactbanner.jpeg";
import { Link } from "react-router-dom";

function Contact() {
  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Contact</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    Contact
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sptb bg-white">
        <div className="container">
          <div className="row">
            <div class="col-lg-12 col-xl-12  col-md-12  d-block mb-7">
              <div class="section-title start-block text-start">
                <h2>Contact Info</h2>
                <p className="text-start mb-5">
                  At HappieDealz, we value your feedback, inquiries, and
                  suggestions. Whether you're a company looking for marketing
                  solutions or a freelance marketer seeking opportunities, we're
                  here to help!
                </p>
                <h3>Get in Touch with Us</h3>
                <p className="text-start mb-5">
                  If you have any questions or need assistance, please reach out
                  through any of the following channels:
                </p>
                <h4>General Inquiries</h4>
                <p className="text-start mb-5">
                  For general questions about our platform, features, or how to
                  get started:
                </p>
              </div>
              <div class="row text-white mb-5">
                <div class="col-lg-6 col-xl-4 col-md-12 h-100">
                  <div class="support-service bg-primary br-2 mb-4 mb-xl-0">
                    <i class="fa fa-home"></i>
                    <p className="text-white">
                      <b>HappieDealz,</b> No:29, Dharmaraja Koil St, Periyapet, Saidapet, Chennai, Tamil Nadu 600015
                    </p>
                  </div>
                </div>
                {/* <div class="col-lg-6 col-xl-4 col-md-12 h-100">
                  <div class="support-service bg-primary br-2 mb-4 mb-xl-0">
                    <i class="fa fa-phone"></i> <h6>Phone</h6>
                    <p className="text-white">+91 9884809607</p>
                  </div>
                </div> */}
                <div class="col-lg-6 col-xl-4 col-md-12 h-100">
                  <div class="support-service bg-primary br-2">
                    <i class="fa fa-envelope-o"></i>
                    <h6>Email</h6>
                    <p className="text-white">info@happiedealz.com</p>
                  </div>
                </div>
              </div>
              {/* <div class="section-title start-block text-start mt-5">
                <h2 className="mt-5">Customer Support</h2>
                <p className="text-start">
                  Need help with your account, subscription, or technical
                  issues? Our support team is here to assist you
                </p>
              </div>

              <div className="row text-white">
                <div class="col-lg-6 col-xl-4 col-md-12 h-100">
                  <div class="support-service bg-primary br-2 mb-4 mb-xl-0">
                    <i class="fa fa-phone"></i> <h6>Phone</h6>
                    <p className="text-white">+91 9884809607</p>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-4 col-md-12 h-100">
                  <div class="support-service bg-primary br-2">
                    <i class="fa fa-envelope-o"></i>
                    <h6>Email</h6>
                    <p className="text-white">support@happiedealz.com</p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div class="container mb-5">
          <div class="row">
            <div class="single-page">
              <div class="section-title start-block text-start mt-5">
                <h2 className="mt-5">Follow Us on Social Media</h2>
                <p className="text-start">
                  Stay connected and follow us for the latest updates,
                  tips, and resources
                </p>
              </div>

              <div className="row text-white">
                <div class="col-lg-6 col-xl-4 col-md-12 h-100">
                  <div class="support-service bg-facebook">
                    <a
                      className="text-white d-flex align-items-center"
                      href="https://www.facebook.com/happiedealz"
                      target="_blank"
                    >
                      <i class="fa fa-facebook"></i>
                      <h6 className="mb-0">Facebook</h6>
                    </a>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-4 col-md-12 h-100">
                  <div class="support-service bg-pink">
                    <a
                      className="text-white d-flex align-items-center"
                      href="https://www.instagram.com/happiedealz"
                      target="_blank"
                    >
                      <i class="fa fa-instagram"></i>
                      <h6 className="mb-0">Instagram</h6>
                    </a>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-4 col-md-12 h-100">
                  <div class="support-service bg-linkedin">
                    <a
                      className="text-white d-flex align-items-center"
                      href="https://www.linkedin.com/company/happie-dealz/about/"
                      target="_blank"
                    >
                      <i class="fa fa-linkedin"></i>
                      <h6 className="mb-0">Linkedin</h6>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-7 col-xl-8 col-md-12 d-block mx-auto">
              <div class="single-page">
                <div class="col-lg-12  col-md-12 mx-auto d-block">
                  <div class="section-title center-block text-center">
                    <h2>Feedback and Suggestions</h2>
                    <p>
                      We’d love to hear from you! Your insights are invaluable
                      in helping us improve our services. Please fill out the
                      feedback form below or send us an email directly.
                    </p>
                  </div>
                  <div class="wrapper wrapper2">
                    <div class="card mb-0">
                      <div class="card-body">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            id="name1"
                            placeholder="Your Name"
                          />
                        </div>
                        <div class="form-group">
                          <input
                            type="email"
                            class="form-control"
                            id="email"
                            placeholder="Email Address"
                          />
                        </div>
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            id="subject"
                            placeholder="Subject"
                          />
                        </div>
                        <div class="form-group">
                          <textarea
                            class="form-control"
                            name="example-textarea-input"
                            rows="6"
                            placeholder="Message"
                          ></textarea>
                        </div>
                        <button class="btn btn-primary">Send Message</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
